import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Space, Row, Col, InputNumber, Spin, Popconfirm, Divider, Table, DatePicker } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
import { paymentMethodOptions, _newLine, isValidDateForm, serializeDateTime } from '@/utils/helpers';
import { createPaymentVoucher, updatePaymentVoucher } from '@/redux/actions/PaymentVoucherActions';
import NumberFormat from 'react-number-format';
import BaseRadioList from '@/components/Elements/BaseRadios';
import moment from 'moment';
import BaseSelect from '@/components/Elements/BaseSelect';
import { getBranchActive } from '@/redux/actions/branchActions';
import ImageSelector from '@/components/ImageSelector';

class PaymentVoucherForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            items: [{
                id: 0,
                name: '',
                price: '',
                quantity: 1,
                amount: 0
            }],
            count: 1,
            images: []
        };
    }

    componentDidMount() {
        this.props.getBranchActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem != this.props.currentItem) {
            if (nextProps?.currentItem?.items && Array.isArray(nextProps?.currentItem?.items)) {
                this.renderNewItem(nextProps?.currentItem?.items)
            } else {
                this.setState({ items: [] })
            }
        }
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                try {
                    const { items, images } = this.state;
                    values.items = items;

                    let finalImages = images;
                    if (this.props.currentItem) {
                        const oldImages = Array.isArray(this.props.currentItem.images)
                            ? this.props.currentItem.images
                            : [];

                        // nếu images đang rỗng thì lấy oldImages
                        if (!finalImages || finalImages.length === 0) {
                            finalImages = oldImages.map((img) => ({
                                manual_id: img.manual_id ?? img.id ?? img.uid ?? null,
                                src: img.src ?? img.url ?? img.originalImage ?? img,
                            })).filter(x => x.src);
                        }
                    }

                    values.images = finalImages;

                    values.payment_at = serializeDateTime(values.payment_at);

                    console.log('values: ', values);

                    if (this.props.currentItem) {
                        await this.props.updatePaymentVoucher(this.props.currentItem.id, values).then((res) => {
                            this.props.reloadData();
                            this.onClose();
                        }).catch(error => {
                            this.setState({ isLoading: false });
                        });

                    } else {
                        await this.props.createPaymentVoucher(values).then((res) => {
                            this.props.reloadData();
                            this.onClose();
                        }).catch(error => {
                            this.setState({ isLoading: false });
                        });

                    }
                    //console.log(values);
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false, items: [], isResetUploadImage: true, images: [] });
    }

    renderNewItem(items = []) {
        let new_items = items.map((item, index) => {
            return {
                id: item.id,
                name: item.name,
                price: item.price,
                quantity: item.quantity,
                amount: item.quantity * item.price
            }
        })
        this.setState({
            items: new_items.filter((v, i, a) => a.findIndex(v2 => (v2.id === v.id)) === i)
        }, () => {
            this.calculateTotalAmount(); // Gọi sau khi setState để đảm bảo rằng state đã được cập nhật
        });
    }

    onDelete(id) {
        let items = this.state.items.filter(item => {
            return item.id != id;
        });
        this.renderNewItem(items)
    }

    async onChangeItem(name, value, itemId) {
        let items = [...this.state.items];
        let index = items.findIndex(item => item.id == itemId);
        let currentItem = items[index];
        currentItem[name] = value;
        items[index] = currentItem;
        this.renderNewItem(items)
    }

    calculateTotalAmount = () => {
        let total_amount = 0;
        this.state.items.forEach(item => {
            total_amount += item.price * item.quantity;
        });
        this.props.form.setFieldsValue({
            total_amount: total_amount
        });
    };

    onAdd() {
        let index = this.state.count + 1;
        let item = {
            id: index,
            name: '',
            price: '',
            quantity: 1,
            amount: 0
        }
        this.setState({
            items: [
                ...this.state.items,
                item
            ],
            count: index
        })
    }

    handleImageChange = (fileList) => {
        const images = (fileList || []).map((file) => ({
            manual_id: file.manual_id ?? file.uid ?? file.id ?? null,
            src: file.originalImage ?? file.src ?? file.url ?? null,
        })).filter(x => x.src);

        this.setState({ images });
    };

    render() {
        var { isLoading, items } = this.state;
        var { visible, currentItem, branchActiveList } = this.props;
        const { getFieldDecorator } = this.props.form;

        var columns = [
            {
                title: "STT",
                dataIndex: "stt",
                width: "40px",
                align: 'center',
                render: (text, record, index) => index + 1
            },
            {
                title: "Tên",
                dataIndex: "name",
                render: (text, record) => {
                    return (
                        <Input
                            value={text}
                            name="name"
                            className='w-100'
                            onChange={(e) => this.onChangeItem(e.target.name, e.target.value, record.id)}
                        />
                    )
                }
            },
            {
                title: "Số lượng",
                dataIndex: "quantity",
                width: '80px',
                render: (text, record) => {
                    return (
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            value={text}
                            name="quantity"
                            min={1}
                            className='w-100'
                            //onChange={(value) => this.onChangeItem('quantity', value, record.id)}
                            onChange={(value) => {
                                // Kiểm tra giá trị và thay thế nếu cần thiết
                                const validValue = value == null || value <= 0 ? 1 : value;
                                this.onChangeItem('quantity', validValue, record.id);
                            }}
                        />
                    )
                }
            },
            {
                title: "Đơn giá",
                dataIndex: "price",
                width: "120px",
                render: (text, record) => {
                    return (
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            value={text}
                            name="price"
                            min={0}
                            className='w-100'
                            onChange={(value) => this.onChangeItem('price', value, record.id)}
                        />
                    )
                }
            },
            {
                title: "Thành tiền",
                dataIndex: "amount",
                width: "120px",
                render: (text, record) => {
                    return (
                        <NumberFormat value={text} displayType={'text'} suffix="đ" thousandSeparator={true} />
                    )
                }
            },
            {
                title: "#",
                align: "center",
                width: '30px',
                render: (text, record) => {
                    return (
                        <Popconfirm
                            title="Xóa bản ghi này?"
                            onConfirm={() => this.onDelete(record.id)}
                        >
                            <DeleteOutlined className='item-action-btn-remove' />
                        </Popconfirm>
                    )
                }
            }
        ];

        var total_amount = 0;
        items.forEach(item => {
            total_amount += item.price;
        });

        return (
            <Drawer
                visible={visible}
                title={currentItem ? 'Sửa phiếu chi' : `Tạo phiếu chi`}
                onOk={(e) => this.submit(e)}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '55%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button size='large' key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                size='large'
                                type="primary"
                                onClick={(e) => this.submit(e)}
                            >
                                {currentItem ? 'Cập nhật' : "Tạo phiếu"}
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Spin tip="Loading..." spinning={isLoading}>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Người nhận tiền">
                                        {getFieldDecorator('recipient', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng điền!',
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.recipient : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Divider orientation="left" orientationMargin="0">
                                        Nội dung chi
                                    </Divider>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Button type="default" size='small' onClick={() => this.onAdd()} icon={<PlusOutlined />}>Thêm dòng</Button>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Table
                                        className='mt-2 mb-4'
                                        size='small'
                                        rowKey='key'
                                        locale={{ emptyText: "Chưa có dữ liệu" }}
                                        tableLayout="auto"
                                        columns={columns}
                                        dataSource={items || []}
                                        pagination={false}
                                        scroll={{
                                            x: 'max-content'
                                        }}
                                        footer={() => {
                                            return (
                                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600' }}>
                                                    <div style={{ marginRight: '10px' }}>Tổng tiền:</div>
                                                    <div>
                                                        {getFieldDecorator('total_amount', {
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message: 'Vui lòng điền!',
                                                                },
                                                            ],
                                                            initialValue: currentItem ? currentItem.total_amount : total_amount
                                                        })(
                                                            <InputNumber
                                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                                className="w-100"
                                                                step={100000}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Cơ sở">
                                        {getFieldDecorator('branch_id', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng điền',
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.branch?.id : null
                                        })(
                                            <BaseSelect
                                                options={branchActiveList || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                placeholder="Chọn một bản ghi"
                                                className="w-100"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Hình thức chi">
                                        {getFieldDecorator('payment_method', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: "Vui lòng chọn!",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.payment_method : null
                                        })(
                                            <BaseRadioList
                                                options={paymentMethodOptions ?? []}
                                                showSearch
                                                placeholder="Chọn hình thức thanh toán"
                                                className="w-100"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ngày chi">
                                        {getFieldDecorator('payment_at', {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: 'Vui lòng chọn!',
                                                },
                                            ],
                                            initialValue: currentItem ? isValidDateForm(currentItem.payment_at, false) : moment()
                                        })(
                                            <DatePicker
                                                className='w-100'
                                                format="DD/MM/YYYY"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: currentItem ? _newLine(currentItem.note) : null
                                        })(
                                            <Input.TextArea rows={3} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ảnh phiếu" className='flex-upload'>
                                        <ImageSelector
                                            key={currentItem?.id || 'new'}
                                            onChangeData={(fileList, changeDetails) => this.handleImageChange(fileList, changeDetails)} // Gắn hàm xử lý thay đổi dữ liệu
                                            multiple={true} // Cho phép chọn nhiều ảnh
                                            maxCount={50} // Giới hạn tối đa 50 ảnh
                                            uploadText="Chọn ảnh"
                                            defaultFileList={currentItem ? currentItem.images : []}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Spin>
                    </Form>
                    : null
                }
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        config: state.config,
        branchActiveList: state.branchReducer.branchActiveList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createPaymentVoucher: (data) => dispatch(createPaymentVoucher(data)),
        updatePaymentVoucher: (id, data) => dispatch(updatePaymentVoucher(id, data)),
        getBranchActive: () => dispatch(getBranchActive())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'PaymentVoucherForm' })(PaymentVoucherForm));
